import { render, staticRenderFns } from "./Cidade-bairro.vue?vue&type=template&id=2fc8a50a&"
import script from "./Cidade-bairro.vue?vue&type=script&lang=js&"
export * from "./Cidade-bairro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports